var _path;

import * as React from "react";

function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.143 10.578H4.857A.857.857 0 014 9.72V7.437c0-.473.384-.856.857-.856h30.286c.473 0 .857.383.857.856v2.284a.857.857 0 01-.857.857zm0 11.42H4.857A.857.857 0 014 21.143v-2.284c0-.473.384-.857.857-.857h30.286c.473 0 .857.384.857.857v2.284a.857.857 0 01-.857.857zm0 11.421H4.857A.857.857 0 014 32.563v-2.284c0-.473.384-.857.857-.857h30.286c.473 0 .857.384.857.857v2.284a.857.857 0 01-.857.856z"
  })));
}

export default SvgHamburgerMenu;